import memoize from '@github/memoize'
import {getEnv} from '@github-ui/client-env'
import {IS_SERVER} from '@github-ui/ssr-utils'
import type {JSFeatureFlag} from './client-feature-flags'

function getEnabledFeaturesSet() {
  return new Set(getEnv().featureFlags as JSFeatureFlag[])
}

const featuresSet =
  IS_SERVER || process.env.NODE_ENV === 'test' || isStorybook() ? getEnabledFeaturesSet : memoize(getEnabledFeaturesSet)

export function getEnabledFeatures(): JSFeatureFlag[] {
  return Array.from(featuresSet())
}

export function isFeatureEnabled(name: JSFeatureFlag): boolean {
  return featuresSet().has(name)
}

// exported to allow mocking in tests
const featureFlag = {isFeatureEnabled}

export {featureFlag}

function isStorybook() {
  try {
    return process?.env?.STORYBOOK === 'true' || process?.env?.APP_ENV === 'storybook'
  } catch {
    return false
  }
}
